import { useState, useEffect } from "react";
import { heroImages } from "@/mocks/images";

export default function Hero() {
  const [current, setCurrent] = useState(0);
  const [prev, setPrev] = useState<number | null>(null);
  const [transitioning, setTransitioning] = useState(false);

  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  const goTo = (index: number) => {
    if (transitioning || index === current) return;
    setPrev(current);
    setTransitioning(true);
    setCurrent(index);
    setTimeout(() => {
      setPrev(null);
      setTransitioning(false);
    }, 800);
  };

  useEffect(() => {
    const interval = setInterval(() => {
      const next = (current + 1) % heroImages.length;
      goTo(next);
    }, 4000);
    return () => clearInterval(interval);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [current, transitioning]);

  return (
    <section id="inicio" className="relative w-full h-screen min-h-[600px] flex items-center justify-center overflow-hidden">

      {/* Previous image (fading out) */}
      {prev !== null && (
        <img
          key={`prev-${prev}`}
          src={heroImages[prev]}
          alt=""
          className="absolute inset-0 w-full h-full object-cover object-center opacity-0 transition-opacity duration-700"
        />
      )}

      {/* Current image (fading in) */}
      {heroImages.map((src, i) => (
        <img
          key={src}
          src={src}
          alt={`Piscina SUPERPISCINAS FLORIN ${i + 1}`}
          className={`absolute inset-0 w-full h-full object-cover object-center transition-opacity duration-700 ${
            i === current ? "opacity-100" : "opacity-0"
          }`}
          style={{ zIndex: i === current ? 1 : 0 }}
        />
      ))}

      {/* Overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-slate-900/60 via-slate-900/40 to-slate-900/70" style={{ zIndex: 2 }}></div>

      {/* Content */}
      <div className="relative w-full text-center px-4 md:px-8 flex flex-col items-center" style={{ zIndex: 3 }}>
        <span className="inline-block bg-cyan-500/20 border border-cyan-400/40 text-cyan-300 text-xs font-semibold uppercase tracking-widest px-4 py-1.5 rounded-full mb-6 backdrop-blur-sm">
          Especialistas en Piscinas desde 2010
        </span>
        <h1 className="text-4xl md:text-6xl lg:text-7xl font-extrabold text-white leading-tight mb-4 max-w-4xl">
          Tu Piscina de Ensueño,{" "}
          <span className="text-cyan-400">Construida por Expertos</span>
        </h1>
        <p className="text-lg md:text-xl text-slate-200 max-w-2xl mb-10 font-light">
          Construcción, mantenimiento y limpieza de piscinas con más de 16 años de experiencia. Calidad garantizada en cada proyecto.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <button
            onClick={() => scrollTo("contacto")}
            className="bg-cyan-500 hover:bg-cyan-400 text-white font-bold px-8 py-4 rounded-full text-base transition-all shadow-lg shadow-cyan-500/30 cursor-pointer whitespace-nowrap"
          >
            Solicita tu Presupuesto →
          </button>
          <button
            onClick={() => scrollTo("galeria")}
            className="border-2 border-white/70 hover:border-white text-white font-semibold px-8 py-4 rounded-full text-base transition-all backdrop-blur-sm cursor-pointer whitespace-nowrap"
          >
            Ver Nuestros Trabajos
          </button>
        </div>

        {/* Stats */}
        <div className="mt-16 flex flex-wrap justify-center gap-8 md:gap-16">
          {[
            { num: "+250", label: "Piscinas Construidas" },
            { num: "+16", label: "Años de Experiencia" },
            { num: "100%", label: "Clientes Satisfechos" },
            { num: "24h", label: "Respuesta Garantizada" },
          ].map((stat) => (
            <div key={stat.label} className="text-center">
              <div className="text-3xl md:text-4xl font-extrabold text-cyan-400">{stat.num}</div>
              <div className="text-slate-300 text-sm mt-1">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>

      {/* Dot indicators */}
      <div className="absolute bottom-20 left-1/2 -translate-x-1/2 flex gap-2" style={{ zIndex: 3 }}>
        {heroImages.map((_, i) => (
          <button
            key={i}
            onClick={() => goTo(i)}
            className={`rounded-full transition-all duration-300 cursor-pointer ${
              i === current
                ? "w-6 h-2 bg-cyan-400"
                : "w-2 h-2 bg-white/40 hover:bg-white/70"
            }`}
          />
        ))}
      </div>


    </section>
  );
}
